import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListarRegistrosComponent } from './listado-registros/listado-registros.component';

const routes: Routes = [{ path: '', component: ListarRegistrosComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
// eslint-disable-next-line prettier/prettier
export class RegistrosRoutingModule {}
